import React from 'react'
import './location.css'
export default function Location() {
    
  return (
    <div className='location'>
      {/*head office*/}
      <br></br>
      <h1 className='heading'>Head office</h1>
      <br/>
      <div className='c1'>
        {/*left content*/}
        <div className='leftside'>
            <h1>Address:</h1>
            <p>2nd Floor, 3-5-239/52, Krishna Nagar, Moula Ali, Secunderabad, Telangana 500040</p>
        </div>
        {/*right side map*/}
        <div className='rightside'>
            <iframe className='map' title='map' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.1734963258546!2d78.56487967369064!3d17.45140818344674!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9c0a1584365d%3A0xd3d130068e5c242!2sSamraj%20Industries!5e0!3m2!1sen!2sin!4v1730281132042!5m2!1sen!2sin"  loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
      </div>

    {/*Branch office*/}
    <h1 className='heading'>Branch office</h1>
    <br></br>
      <div className='c2'>
        {/*left content*/}
        <div className='leftside'>
            <iframe className='map' title='map' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.1734963258546!2d78.56487967369064!3d17.45140818344674!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9c0a1584365d%3A0xd3d130068e5c242!2sSamraj%20Industries!5e0!3m2!1sen!2sin!4v1730281132042!5m2!1sen!2sin"  loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
        {/*right side map*/}
        <div className='rightside'>
            <h1>Address:</h1>
            <p>2nd Floor, 3-5-239/52, Krishna Nagar, Moula Ali, Secunderabad, Telangana 500040</p>
        </div>
      </div>
      <br/>
    </div>
  )
}
